import { Box, CircularProgress } from "@mui/material";
import { ROUTES } from "constants/routes";
import { db } from "firebase-config/firebase";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setUnReadMessages } from "slices/authReducers";
import { fetchCart } from "slices/cartReducer";
import { setAppNotifications } from "slices/notificationReducer";
import { getUserProfile } from "slices/userReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { getAuthUserId } from "utils/auth.util";

const PrivateLayout = ({ children }: any) => {
  const { authReducer }: any = useAppSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!authReducer.isLoggedIn && !authReducer.isLoadingAuth) {
      navigate(`${ROUTES.SIGNIN}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authReducer]);

  useEffect(() => {
    if (!authReducer.isLoggedIn) {
      return;
    }

    dispatch(fetchCart({ query: "" }));
    dispatch(getUserProfile());
    const loggedInUserId = getAuthUserId();
    const unReadNotifications = onSnapshot(
      query(
        collection(db, "notifications"),
        where("userId", "==", loggedInUserId)
      ),
      (res) => {
        if (res.docs?.[0]?.data()?.notificationCount > 99) {
          dispatch(setAppNotifications("99+"));
        } else {
          dispatch(
            setAppNotifications(res.docs?.[0]?.data()?.notificationCount ?? 0)
          );
        }

        // dispatch(fetchNotifications({ page: 1 }))
      }
    );
    return unReadNotifications;
  }, [authReducer.isLoggedIn, dispatch]);

  useEffect(() => {
    if (!authReducer.isLoggedIn) {
      return;
    }
    const loggedInUserId = getAuthUserId();
    const unReadMessages = onSnapshot(
      query(
        collection(db, "conversations"),
        where("participants", "array-contains", loggedInUserId),
        where("messagedBy", "!=", loggedInUserId)
      ),
      (res) => {
        dispatch(
          setUnReadMessages(
            res.docs
              .filter((f: any) => f?.data()?.lastMessageCount > 0)
              .map((unr: any) => ({ id: unr.id, ...unr.data() }))
          )
        );
      }
    );
    return unReadMessages;
  }, [authReducer.isLoggedIn, dispatch]);

  if (authReducer.isLoadingAuth) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return <>{children}</>;
};

export default PrivateLayout;
